// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wvbS","textarea":"styles_textarea__TAeNX"};